var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { Component, Input } from '@angular/core';
import { ViewPresetSize } from './view-preset-size';
import { ConfigureViewType } from '../../shared/configure-view-type';
import * as _ from 'lodash';
var ViewGeneralSettingComponent = /** @class */ (function (_super) {
    __extends(ViewGeneralSettingComponent, _super);
    function ViewGeneralSettingComponent(injector, viewTypeService) {
        var _this = _super.call(this, injector) || this;
        _this.viewTypeService = viewTypeService;
        _this.configureViewTypes = { popView: ConfigureViewType.PopView };
        _this.usablePresetSizes = [];
        return _this;
    }
    Object.defineProperty(ViewGeneralSettingComponent.prototype, "popViewSetting", {
        get: function () {
            return this.data.popViewSetting;
        },
        enumerable: true,
        configurable: true
    });
    ViewGeneralSettingComponent.prototype.ngOnChanges = function (changes) {
        var dataItem = changes['data'].currentValue;
        if (!dataItem) {
            this.active = false;
        }
        else {
            this.active = true;
        }
    };
    ViewGeneralSettingComponent.prototype.ngOnInit = function () {
        this.viewTypeDisplayName = this.viewTypeService.getViewTypeDisplayName(this.data.viewType);
        if (this.data.viewType === ConfigureViewType.Web) {
            this.usablePresetSizes = ViewPresetSize.presetWebSizes;
        }
        else if (this.data.viewType === ConfigureViewType.Mobile) {
            this.usablePresetSizes = ViewPresetSize.presetMobileSizes;
        }
        this.caculteSelectedPresetSizeId();
    };
    ViewGeneralSettingComponent.prototype.caculteSelectedPresetSizeId = function () {
        var _this = this;
        var selectedPresetSize = this.usablePresetSizes.find(function (s) { return s.width === _this.data.width && s.height === _this.data.height; });
        if (selectedPresetSize) {
            this._selectedPresetSizeId = selectedPresetSize.id;
        }
        else {
            this._selectedPresetSizeId = 0;
        }
    };
    Object.defineProperty(ViewGeneralSettingComponent.prototype, "selectedPresetSizeId", {
        get: function () {
            return this._selectedPresetSizeId;
        },
        set: function (id) {
            var _this = this;
            this._selectedPresetSizeId = +id;
            var selectedPresetSize = this.usablePresetSizes.find(function (s) { return s.id === _this._selectedPresetSizeId; });
            if (selectedPresetSize && selectedPresetSize.width && selectedPresetSize.height) {
                this.data.width = selectedPresetSize.width;
                this.data.height = selectedPresetSize.height;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewGeneralSettingComponent.prototype, "width", {
        get: function () {
            return this.data.width;
        },
        set: function (width) {
            if (this.data.width === width) {
                return;
            }
            this.data.width = width;
            this.caculteSelectedPresetSizeId();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewGeneralSettingComponent.prototype, "height", {
        get: function () {
            return this.data.height;
        },
        set: function (height) {
            if (this.data.height === height) {
                return;
            }
            this.data.height = height;
            this.caculteSelectedPresetSizeId();
        },
        enumerable: true,
        configurable: true
    });
    ViewGeneralSettingComponent.prototype.checkWidthSize = function (currentFormControl) {
        if (_.isNil(currentFormControl.value)) {
            return undefined;
        }
        if (!_.isNumber(currentFormControl.value)) {
            return undefined;
        }
        var value = Number(currentFormControl.value);
        if (value < 0) {
            return undefined;
        }
        if (value < 1 || value > 5000) {
            return { WidthRangeError: true };
        }
        return undefined;
    };
    ViewGeneralSettingComponent.prototype.checkHeightSize = function (currentFormControl) {
        if (_.isNil(currentFormControl.value)) {
            return undefined;
        }
        if (!_.isNumber(currentFormControl.value)) {
            return undefined;
        }
        var value = Number(currentFormControl.value);
        if (value < 0) {
            return undefined;
        }
        if (value < 1 || value > 5000) {
            return { HeightRangeError: true };
        }
        return undefined;
    };
    __decorate([
        Input()
    ], ViewGeneralSettingComponent.prototype, "data", void 0);
    ViewGeneralSettingComponent = __decorate([
        Component({
            selector: 'view-general-setting',
            template: "<div class=\"design-view-general-setting\"> <div class=\"fe-modal-content\" provide-parent-forms> <div *ngIf=\"active\" class=\"clearfix\"> <div class=\"fe-vertical-label\"> <div class=\"fe-vertical-title\"> <i class=\"star\">*</i> {{lc('ConfigureViewName')}}: </div> <input type=\"text\" class=\"fe-vertical-input\" name=\"ConfigureViewName\" [(ngModel)]=\"data.name\" max-length=20 required pattern=\"^[\u4e00-\u9fa5a-zA-Z0-9\_\-]+$\" #ConfigureViewName=\"ngModel\" /> <div class=\"fe-vertical-title has-danger\"> <div class=\"form-control-feedback\" *ngIf=\"ConfigureViewName.invalid && (ConfigureViewName.dirty || ConfigureViewName.touched)\"> <span [hidden]=\"!ConfigureViewName.errors.pattern\">{{lc(\"NameHasSpecialCharacters\")}}</span> <span *ngIf=\"ConfigureViewName.errors.required\"> {{l('RequiredField',lc('ConfigureViewName'))}}</span> <span *ngIf=\"ConfigureViewName.errors.maxLength\">{{l('FieldValue',lc('ConfigureViewName'))}}{{l('LengthNotMoreThan',20)}}</span> </div> </div> </div> <div class=\"fe-vertical-label margin-top-5\" *ngIf=\"data.viewType != configureViewTypes.popView\"> <div class=\"fe-vertical-title\">{{lc('PresetSize')}}:</div> <select #sizeTypeSelect class=\"fe-vertical-input\" name=\"viewType\" [(ngModel)]=\"selectedPresetSizeId\"> <option *ngFor=\"let presetSize of usablePresetSizes\" [value]=\"presetSize.id\"> {{lc(presetSize.name)}} </option> </select> </div> <div class=\"clearfix  margin-top-5\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc('Width')}}:</div> <input type=\"number\" class=\"fe-vertical-input\" not-negative-integer name=\"ConfigureViewWidth\" [(ngModel)]=\"width\" [custom-func-validate]=\"checkWidthSize\" #ConfigureViewWidth=\"ngModel\" required/> <div class=\"has-danger\"> <div class=\"form-control-feedback\" *ngIf=\"ConfigureViewWidth.invalid && (ConfigureViewWidth.dirty || ConfigureViewWidth.touched)\"> <span *ngIf=\"ConfigureViewWidth.errors.required\"> {{l('RequiredField',lc('Width'))}}</span> <span *ngIf=\"ConfigureViewWidth.errors.notNegativeInteger\"> {{l('FieldValue',lc('Width'))}}{{l('NotNegativeInteger')}};</span> <span *ngIf=\"ConfigureViewWidth.errors.WidthRangeError\">{{l('FieldValue',lc('Width')) }}{{lc('ViewWidthHeightRangeError')}};</span> </div> </div> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc('Height')}}:</div> <input type=\"number\" class=\"fe-vertical-input\" not-negative-integer name=\"ConfigureViewHeight\" [(ngModel)]=\"height\" [custom-func-validate]=\"checkHeightSize\" #ConfigureViewHeight=\"ngModel\" required/> <div class=\"has-danger\"> <div class=\"form-control-feedback\" *ngIf=\"ConfigureViewHeight.invalid && (ConfigureViewHeight.dirty || ConfigureViewHeight.touched)\"> <span *ngIf=\"ConfigureViewHeight.errors.required\"> {{l('RequiredField',lc('Height'))}}</span> <span *ngIf=\"ConfigureViewHeight.errors.notNegativeInteger\">{{l('FieldValue',lc('Height')) }}{{l('NotNegativeInteger')}};</span> <span *ngIf=\"ConfigureViewHeight.errors.HeightRangeError\"> {{l('FieldValue',lc('Height')) }}{{lc('ViewWidthHeightRangeError')}};</span> </div> </div> </div> <div *ngIf=\"data.viewType != configureViewTypes.popView \" class=\"modify-size-warning fe-vertical-title\"> {{lc('ModifyViewSizeWarning',viewTypeDisplayName)}} </div> </div> </div> <view-pop-setting *ngIf=\"data.viewType === configureViewTypes.popView && data.popViewSetting\" [data]=\"data.popViewSetting\"></view-pop-setting> </div> </div>",
            styles: [".design-view-general-setting { input[type='text'], input[type='number'] { height: 30px; } .modify-size-warning { color: sandybrown; padding-top: 5px; } .form-group.preset-sizes { margin-bottom: 0px; } .form-group.size { margin-bottom: 0.5em; } .star { color: red; } }"]
        })
    ], ViewGeneralSettingComponent);
    return ViewGeneralSettingComponent;
}(ConfigureComponentBase));
export { ViewGeneralSettingComponent };
